import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Popup from 'reactjs-popup';
import axios from "axios";
import Cookies from "js-cookie";
import styles from "./Section11Downloadpdf.module.css";
import ShowPopupButton from "../PopupModal/ShowPopupButton";

import image1 from "../../Images/pdf/zinnov-nasscom0.jpg";
import image2 from "../../Images/pdf/zinnov-nasscom1.jpg";
import image3 from "../../Images/pdf/zinnov-nasscom2.jpg";
import image4 from "../../Images/pdf/zinnov-nasscom3.jpg";
import image5 from "../../Images/pdf/zinnov-nasscom4.jpg";

const images = [image1, image2, image3, image4, image5];
const previewCount = 4;

const Section11DownloadImages = ({ onDownloadClick }) =>  {
  const swiperRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  
  const handleCustomNext = () => {
    const swiper = swiperRef.current;
    if (!swiper) return;
  
    const maxIndex = swiper.slides.length - 1;
    const nextIndex = (swiper.activeIndex - 1) + 1;

    if (nextIndex <= maxIndex) {
      swiper.slideTo(nextIndex);
    }
  };

  return (
    <div className="download-pdf-container">
    <div id="image-preview-slider" className={styles.Sec11Container}>
      <h4 className={styles.heading}>VIEW REPORT</h4>

      <div className={styles.SubSec11Container}>
        <Swiper
          className="mySwiper"
          modules={[Navigation]}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          slidesPerView={1}
          spaceBetween={20}
          centeredSlides={true} // keep it if needed
          watchSlidesProgress={true}
          slideToClickedSlide={true}
          navigation={{
            nextEl: `.${styles.rightArrow}`,
            prevEl: `.${styles.leftArrow}`,
          }}
        >
          {images.slice(0, previewCount).map((img, index) => (
            <SwiperSlide key={index}>
              <div className={styles.slideContent}>
                <div className={styles.slideImageWrapper}>
                  <img
                    src={img}
                    alt={`Page ${index + 1}`}
                    className={styles.slideImage}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
          {images.length > previewCount && (
            <SwiperSlide>
              <div className={styles.slideContent}>
                <div className={styles.slideImageWrapper}>
                  <img
                    src={images[previewCount]}
                    alt="Locked Preview"
                    className={styles.slideImage}
                  />
                  <div className={styles.persistentOverlay}></div>
                  <div className={styles.downloadOverlay}>
                    <div className="PopupContainer"><ShowPopupButton type="red" uniqueId="section3"/></div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          )}
        </Swiper>

        <button
          className={`${styles.customArrow} ${styles.leftArrow}`}
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <img
            src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/right-arrow-circle.svg"
            alt="Previous"
            loading="lazy"
          />
        </button>
        <button
          className={`${styles.customArrow} ${styles.rightArrow}`}
          onClick={() => handleCustomNext()}
        >
          <img
            src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/right-arrow-circle.svg"
            alt="Next"
            loading="lazy"
          />
        </button>
      </div>

       <div id="popup-target-section3"></div>
    </div>
    <div className={styles.authorsSection}>
            <div className={styles.authorDetails}>
              {/* <div className='closed'> */}
                <h5 id="authors-title">Authors</h5>
                {/* <div class='author-icon-block' onClick={toggleExpand}>
                  <span style={{ marginTop: isExpanded ? '-2px' : '0' }}>
                    {isExpanded ? '-' : '+'}
                  </span>
                </div> */}
              {/* </div> */}
              {/* {isExpanded && ( */}
                <div className={styles.authorsGrid}>
                  <span className="author" id="author-1">
                    <p className="author-name">Achyuta Ghosh</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Senior Director and Head - Insights</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>nasscom</p>
                  </span>
                  <span className="author" id="author-2">
                    <a className="author-name" href='https://zinnov.com/nitika-goel/' target='_blank'>Nitika Goel</a>
                    <p className="author-title authortext" style={{ color: '#939393' }}>CMO & Managing Partner</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                  <span className="author" id="author-3">
                  <a className="author-name" href='https://zinnov.com/namita-adavi/' target='_blank'>Namita Adavi</a>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Partner</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                  <span className="author" id="author-4">
                    <p className="author-name">Sneha Sharma</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Senior Analyst - Insights</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>nasscom</p>
                  </span>
                  <span className="author" id="author-5">
                    <p className="author-name">Animesh Kumar Jain</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Project Lead</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                  <span className="author" id="author-6">
                    <p className="author-name">Varun K R Aithal</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Consultant</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                </div>
              {/* )} */}
            </div>
          </div>
    </div>
  );
};

export default Section11DownloadImages;